import React from "react";
import "../../src/style/buttons.scss"
import "../../src/style/block.scss"
import "../../src/style/variables.scss"
import "../../src/style/feature.scss"
import "../../src/style/typography.scss"
import "../../src/style/forms.scss"
import { GrActions } from "react-icons/gr";

const ComponentUi: React.FC = () => {

  return (
    <div className="ui">

        <p>Buttony</p>
        <b>Small |  fill | small padding</b>
          <div className="ui flex-start-center">
            <button className="button small padding-small button-fill-main">Wiadomość <GrActions className="icon"/></button>
            <button className="button small padding-small button-fill-second"> Wiadomość <GrActions className="icon"/></button>
            <button className="button small padding-small button-fill-background-main"> Wiadomość <GrActions className="icon"/></button>
            <button className="button small padding-small button-fill-disable"> Wiadomość <GrActions className="icon"/></button>
           </div>

      <b>Small | outline |small padding</b>

      <div className="ui flex-start-center">
            <button className="button small padding-small button-outline-main">Wiadomość <GrActions className="icon"/></button>
            <button className="button small padding-small button-outline"> Wiadomość <GrActions className="icon"/></button>
            </div>

            <p>Mogą byc też warianty dwu kolorowe</p>

            <div className="ui flex-start-center">
            <button className="button small padding-small button-outline-main">Wiadomość <GrActions className="icon-second"/></button>
            <button className="button small padding-small button-outline"> Wiadomość <GrActions className="icon"/></button>
            </div>

            <b>Toggle boxy</b>
      
    </div>
  );
};

export default ComponentUi;
